import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  FormControl,
  InputLabel,
  FormControlLabel,
  MenuItem,
  Paper,
  IconButton,
  Select,
  TextField,
  Typography, 
  Checkbox} from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import React from 'react';
import Utils from '../share/Utils';
import { format, parse } from 'date-fns';
import VariantSnackbar from '../share/VariantSnackbar';
import TrashIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import FormDialogGuiasLoteRecurso from './FormDialogGuiasLoteRecurso';
import MUIDataTable from 'mui-datatables';
import { withUsuario } from '../../contexts/UsuarioContext';
import FaturaApi from '../../api/FaturaApi';
import GuiaApi from '../../api/GuiaApi';
import AlertDialogSlide from '../share/AlertDialogSlide';
import DialogErrosDemonstrativos from '../financeiro/DialogErrosDemonstrativos';
import DrawerGuiaRecurso from '../share/DrawerGuiaRecurso';
import { NoteAdd } from '@material-ui/icons';


const styles = theme => ({
  paper: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  body: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  divAdicionarGuias: {
    textAlign: 'center'
  },  
  divTitle: {
    width:'30%',
    display: 'inline-flex',
  },  
  divBotoes: {
    width:'69%',
    display: 'inline-flex',
    justifyContent: 'flex-end',
  },  
  buttonAcoes: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2.5),
    marginTop: theme.spacing(1.5),
  },  
  titleEditavel: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
  },
  titleNotEditavel: {
    marginTop: theme.spacing(-2),
    marginBottom: theme.spacing(-3),
  },  
  formControlAutoCompleteDemonstrativo: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    minWidth: 330,
  },  
  textFieldFilter: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(0.8),
    marginBottom: theme.spacing(1),
    minWidth: 330,
  },  
  typographyTituloPaper: {
    marginLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontSize: 13,
    minWidth: 600,
  },
  selectTipoGuia: {
    marginLeft: theme.spacing(4),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.8),
    minWidth: 500,
  },  
  buttonAdicionarGuias: {
    margin: theme.spacing(2),
  },
  fontTable: {
    fontSize: 12
  },
  fontTableHist: {
    fontSize: 11
  },
  checkBox: {
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  invisible: {
    display: 'none',
  },
  iconButton: {
    marginLeft: theme.spacing(2),
    padding: '3px'
  },
  paperPrincipal: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(1),
  },
  typographyLabelPaper: {
    fontSize: 13,    
    marginLeft: theme.spacing(20),
    display: 'inline-flex',
    fontWeight: 'bold',
    width: 200,
    marginTop: theme.spacing(1.2),
  },
  typographyDetalhe: {
    fontSize: 13,    
    marginLeft: theme.spacing(1),
    display: 'inline-flex',
    width: 500,
    marginBottom: theme.spacing(1.2),
  },
  typographyDetalheCancelado: {
    fontSize: 13,    
    marginLeft: theme.spacing(1),
    display: 'inline-flex',
    width: 500,
    marginBottom: theme.spacing(1.2),
    color: 'red',
  },  
  paperTotal: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0),
  },
  typographyTotalValor: {
    fontSize: 13,    
    marginLeft: theme.spacing(35),
    display: 'inline',
    fontWeight: 'bold',
  },
  typographyTotalValorDetalhe: {
    fontSize: 13,    
    marginLeft: theme.spacing(1),
    display: 'inline',
  },  
  paperDetalhes: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(-0.8),
  },  
  paperHistorico: {
    marginTop: theme.spacing(1.8),
    marginBottom: theme.spacing(1),
  },  
  typographyLabelPaperRecurso: {
    fontSize: 13,    
    marginLeft: theme.spacing(9),
    display: 'inline-flex',
    fontWeight: 'bold',
    width: 211,
    marginTop: theme.spacing(1.2),
  },
  typographyDetalheRecurso: {
    fontSize: 13,    
    marginLeft: theme.spacing(1),
    display: 'inline-flex',
    width: 110,
    marginBottom: theme.spacing(1.2),
  },

});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '0px',
        },
      },
    }
  });
class FormDialogLoteRecurso extends React.Component {
  utils = new Utils();
  faturaApi = new FaturaApi();
  guiaApi = new GuiaApi();
  constructor (props) {
    super(props);
    this.state = {      
      ...this.props.lote,
      lote: this.props.lote,
      snackOpen: false,
      snackMessage: '',
      sucesso: false,      
      numDemonstrativoSelected: 0,
      codTipoGuiaSelected: 0,
      fetchingFilter: false,
      fetching: false,
      numProtocoloSelected: '',
      numProtocoloNovoSelected: '',
      openDialogGuias: false,
      guias: [],
      novasGuias: [],
      historicoLote: [],
      jaAuditadoPapel: false,
      seqPrestadorSelected: this.props.codPrestador === undefined ? 0 : this.props.codPrestador, 
      nomePrestadorSelected: this.props.nomPrestador === undefined ? '' : this.props.nomPrestador,  
      modoInclusao: this.props.modoInclusao,
      openDialogEnvioFaturamento: false,
      demonstrativosSemErros: [],
      guiaOriginal: {}, 
      guiaOriginalOpen: false,
      modoEdicaoGuia: false,
      adicionouGuias: false
    };
  }

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  componentDidMount = async () => {
    if (!this.props.modoInclusao){
      this.setState({fetching: true});
      let guias = await this.guiaApi.getGuiasLote(this.state.codLoteGuia);
      let historicoLote = [];
      this.props.lote.historicoEstados.map(res => {
        const { codLote, dtaCadastro, codEstadoProtocolo, desEstadoProtocolo, codUsuario, nomUsuario } = res;
        historicoLote.push(Object.values({ codLote, codEstadoProtocolo, desEstadoProtocolo, dtaCadastro, codUsuario, nomUsuario }));
      });      
      this.setState({fetching: false, guias: guias, historicoLote: historicoLote, 
        numDemonstrativoSelected: this.state.lote.numDemonstrativoPagRecorrido,
        codTipoGuiaSelected: this.state.lote.codTipoGuia});
    }
  }

  handleChange = async event => {
    if (event.target.name === 'numProtocoloSelected' || event.target.name === 'numProtocoloNovoSelected'){
      this.setState({[event.target.name]: event.target.value.toUpperCase().substring(0, 12)});       
      if (event.target.name === 'numProtocoloSelected'){
        await this.handleClickLimpar();  
      }
    } else {
      this.setState({[event.target.name]: event.target.value});    
    }
  }
  
  getSuggestionValueDemonstrativo = (suggestion, id) => {        
    this.setState({numDemonstrativoSelected: id !== undefined ? id : suggestion.id, nomeDemonstrativo: suggestion.nome, numProtocoloSelected: ''});
    return suggestion.nome;
  }
  handleClickLimpar = async () => {
    this.setState({fetchingFilter: true});
    await this.setState({  
      numDemonstrativoSelected: 0,
    });
    this.setState({fetchingFilter: false});    
  }  
  handleClickAdicionarGuias = async () => {
    this.setState({openDialogGuias: true});
  }
  handleCloseAdicionarGuias = async () => {
    this.setState({openDialogGuias: false});
  }
  handleSaveAdicionarGuias = async (guias) => {
    if(this.state.modoInclusao){
      let guiasAux = this.state.guias;
      guiasAux = guiasAux.concat(guias);
      guiasAux = guiasAux.sort(function (a, b) {
        if (a[0] === b[0]) return 0;
        return a[0] < b[0] ? -1 : 1;
      });
      this.setState({openDialogGuias: false, guias: guiasAux});
    } else {
      let novasGuias = this.state.novasGuias;
      novasGuias = novasGuias.concat(guias);
      novasGuias = novasGuias.sort(function (a, b) {
        if (a[0] === b[0]) return 0;
        return a[0] < b[0] ? -1 : 1;
      });

      let guiasAux = this.state.guias;
      guiasAux = guiasAux.concat(guias);
      guiasAux = guiasAux.sort(function (a, b) {
        if (a[0] === b[0]) return 0;
        return a[0] < b[0] ? -1 : 1;
      });
      this.setState({openDialogGuias: false, guias: guiasAux, novasGuias: novasGuias, adicionouGuias: true});

    }
  }      
  handleChangeJaAuditadoPapel = () => {
    this.setState({ jaAuditadoPapel: !this.state.jaAuditadoPapel });
  }
  handleClickSave = async () => {

    let codigosGuias = [];
    if(this.state.modoInclusao){
      for (var i = 0; i < this.state.guias.length; i++) {
        codigosGuias.push(this.state.guias[i][0]);
      }
    } else {
      for (var i = 0; i < this.state.novasGuias.length; i++) {
        codigosGuias.push(this.state.novasGuias[i][0]);
      }
    }
    let lote = {
      codLoteGuia: this.state.codLoteGuia === undefined || this.state.codLoteGuia === null ? 0 : this.state.codLoteGuia,
      seqPrestador: this.state.seqPrestadorSelected === undefined ? 0 : this.state.seqPrestadorSelected,
      numDemonstrativo: this.state.numDemonstrativoSelected === undefined ? 0 : this.state.numDemonstrativoSelected,
      codTipoGuia: this.state.codTipoGuiaSelected,
      numProtocolo: this.state.numProtocoloSelected === '' ? 'vazio' : this.state.numProtocoloSelected,
      numLoteRecurso: this.state.numProtocoloNovoSelected,
      indLoteRecursoAuditadoPapel: this.state.jaAuditadoPapel ? 'S' : 'N',
      codGuiasSelecionadas: codigosGuias,
    };
    this.setState({fetching: true});    
    let codLote = await this.props.handleSave(lote);
    this.setState({fetching: false});    
    if (codLote !== 0) {
      await this.consultarLoteAposAcao(codLote);
      this.setState({modoInclusao: false, fetching: false, fetchingFilter: false});
    }
  }

  enviarParaFaturamento = async () => {
    this.setState({openDialogEnvioFaturamento: true, 
      dialogTitle: 'Envio de Lote para Faturamento', 
      dialogMessage: 'Confirma o envio do lote ' + this.state.lote.numLotePrestador + ' para faturamento?'});
  }

  handleCloseDialogEnvioFaturamento = () => {
    this.setState({ openDialogEnvioFaturamento: false });
  }    

  handleDialogConfirmEnvioFaturamento = async () => {
    this.setState({ openDialogEnvioFaturamento: false, fetching: true });
    let result = await this.faturaApi.envioFaturamento(this.state.lote.codLoteGuia, this.state.lote.numLotePrestador);
    this.onOperacaoFinalizada(result);    
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {    
      await this.consultarLoteAposAcao(this.state.lote.codLoteGuia);
    } else {
      this.setState({fetching: false});
    }
  }  

  onOperacaoFinalizada = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        snackSucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          snackSucesso: true,
          fetching: false});
      } else {
        this.setState({
          openDialogValidacao: true,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }  

  handleDialogValidacaoClose = () => {
    this.setState({openDialogValidacao: false});
  }

  consultarLoteAposAcao = async (codLote) => {
    this.setState({fetchingFilter: true, fetching: true});
    let lotes = await this.faturaApi.consultarFaturasPorPrestadorCodigoStatus(0, 'vazio', 0, 'vazio', 'vazio', 'vazio', 99, codLote, 'vazio', 0, 0, 0, 'S', parse(new Date(0)), parse(new Date()));       
    lotes[0].dtaFimRecGlosa = format(parse(lotes[0].dtaFimRecGlosa), 'DD/MM/YYYY');
    let historicoLote = [];
    lotes[0].historicoEstados.map(res => {
      const { codLote, dtaCadastro, codEstadoProtocolo, desEstadoProtocolo, codUsuario, nomUsuario } = res;
      historicoLote.push(Object.values({ codLote, codEstadoProtocolo, desEstadoProtocolo, dtaCadastro, codUsuario, nomUsuario }));
    });      
    let guias = await this.guiaApi.getGuiasLote(codLote);
    this.setState({fetchingFilter: false, fetching: false, historicoLote: historicoLote, lote: lotes[0], guias: guias});
  }

  handleClickExcluirGuia = async (event, tableMeta) => {
    if (this.state.modoInclusao) {
       //|| (!this.state.modoInclusao && this.state.guias[tableMeta.rowIndex][9] !== '')){

      let guiasAux = this.state.guias.slice();
      guiasAux.splice(tableMeta.rowIndex, 1);
      let index = 0;
      for (var i = 0; i < this.state.novasGuias.length; i++) {
        if(this.state.novasGuias[i][0] === this.state.guias[tableMeta.rowIndex][0]){
          index = i;
          break;
        }
      }
      let novasGuias = this.state.novasGuias.slice();
      novasGuias.splice(index, 1);
      this.setState({guias: guiasAux, novasGuias: novasGuias});
    } else {
      let codGuia = this.state.guias[tableMeta.rowIndex][0];
      let result = await this.guiaApi.excluirGuiaRecurso(this.state.codLoteGuia, codGuia);
      await this.consultarLoteAposAcao(this.state.codLoteGuia);
    }
  }    
  handleClickVisualizarGuia = async (event, tableMeta) => {
    this.setState({fetchingFilter: true});
    let codGuia = this.state.guias[tableMeta.rowIndex][0];
    const guiaOriginal = await this.guiaApi.consultarGuiaOriginal(codGuia, 0);
    this.setState({guiaOriginal: guiaOriginal, guiaOriginalOpen: true, modoEdicaoGuia: false, fetchingFilter: false});
  }    
  handleClickEditarGuia = async (event, tableMeta) => {
    this.setState({fetchingFilter: true});
    let codGuia = this.state.guias[tableMeta.rowIndex][0];
    const guiaOriginal = await this.guiaApi.consultarGuiaOriginal(codGuia, 0);
    this.setState({guiaOriginal: guiaOriginal, guiaOriginalOpen: true, modoEdicaoGuia: true, fetchingFilter: false});
  }    
  handleCloseGuiaOriginal = async () => {
    this.setState({guiaOriginal: {}, guiaOriginalOpen: false});
    if (this.state.modoEdicaoGuia){
      await this.consultarLoteAposAcao(this.state.codLoteGuia)
    }

  }

  render () {
    const options = {
      print: false,
      download: false,
      selectableRows: 'none',
      filterType: 'dropdown',
      rowsPerPageOptions: [50, 100, 500, 1000, 1500],
      rowsPerPage: 50,
      viewColumns: false,
      filter: false,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>guia(s) selecionada(s)</Typography>
        },
      }
    };
    const optionsHistorico = {
      print: false,
      download: false,
      search: false,
      viewColumns: false,
      filter: false,
      pagination: false,
      selectableRows: 'none',
      filterType: 'dropdown',
    };        
    const columns = [
      {
        name: 'codGuia',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nº da Guia do Prestador',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nº da Guia da Operadora',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Carteira',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Valor Processado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },      
      {
        name: 'Valor Liberado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },      
      {
        name: 'Valor Glosado',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            const nf = new Intl.NumberFormat('pt-BR', {
              style: 'currency',
              currency: 'BRL',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return <Typography className={classes.fontTable}>{nf.format(value)}</Typography>;
          },
        }
      },      
      {
        name: 'versão',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nº Fatura',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTable}>{value}</Typography>;
          },
        }
      },    
      {
        name: 'Ações',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <div>
              <IconButton
                id={'menuButton'}
                className={(this.state.situacao !== 'NÃO ENVIADO' && this.state.situacao !== undefined) ? classes.invisible : classes.iconButton}
                size='small'
                title={'Excluir guia da lista'}
                onClick={event => this.handleClickExcluirGuia(event, tableMeta)}
              >
                <TrashIcon fontSize='small' />
              </IconButton>
              <IconButton
              id={'menuButton'}
              className={this.state.modoInclusao ? classes.invisible : classes.iconButton}
              size='small'
              title={'Visualizar Guia'}
              onClick={event => this.handleClickVisualizarGuia(event, tableMeta)}
              >
                <VisibilityIcon fontSize='small' />
              </IconButton>
              <IconButton
              id={'menuButton'}
              className={this.state.modoInclusao && this.state.situacao !== 'NÃO ENVIADO' ? classes.invisible : classes.iconButton}
              size='small'
              title={'Editar Guia'}
              onClick={event => this.handleClickEditarGuia(event, tableMeta)}
              >
                <EditIcon fontSize='small' />
              </IconButton>
            </div>
          );
          },
        }
      },    
    ];
    const columnsHistorico = [
      {
        name: 'codLote',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codEstadoProtocolo',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Estado',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTableHist}>{value}</Typography>;
          },
        }
      },
      {
        name: 'Data Recebimento',
        options: {
          searchable: false,
          customBodyRender: (value) => {
            return <Typography variant='overline' className={classes.fontTableHist}>{format(new Date(value), 'DD/MM/YYYY hh:mm:ss')}</Typography>;
          },
        }
      },
      {
        name: 'codUsuario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return <Typography className={classes.fontTableHist}>{value}</Typography>;
          },
        }
      },
    ];
    const { classes, open, handleClose, titulo, numerosDemostrativos } = this.props;
    const { numProtocoloSelected, codTipoGuiaSelected, numDemonstrativoSelected, 
            fetching, fetchingFilter, guias, openDialogGuias, numProtocoloNovoSelected, jaAuditadoPapel } = this.state;    
    const nf = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });            
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='xl'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle className={!this.state.modoInclusao ? classes.titleNotEditavel : classes.titleEditavel}>
            <div className={classes.divTitle}>
              {titulo}
            </div>
            <div className={classes.divBotoes}>
              <Button
                  color='primary'
                  variant='outlined'
                  size='small'
                  title='Clique para imprimir o protocolo'
                  className={this.state.modoInclusao ? classes.invisible : classes.buttonAcoes}     
                  disabled={this.state.lote.situacao === 'NÃO ENVIADO'}
                  onClick={this.props.imprimirProtocolo}
                  id={'impressaoProtocolo'}>
                  Imprimir Protocolo
              </Button>
              <Button
                  color='primary'
                  variant='outlined'
                  size='small'
                  title='Clique para enviar o lote para faturamento'
                  className={this.state.modoInclusao ? classes.invisible : classes.buttonAcoes}     
                  disabled={this.state.lote.situacao !== 'NÃO ENVIADO'}
                  onClick={this.enviarParaFaturamento}
                  id={'envioFaturamento'}>
                  Enviar para Faturamento
              </Button>
            </div>
          </DialogTitle>
          {this.state.modoInclusao
          ? <DialogContent>
            <Paper className={classes.body} elevation={1}>
              <div>
              <FormControl>
                <Typography className={classes.typographyTituloPaper}>
                  Informar o demonstrativo de pagamento ou protocolo que se deseja recorrer:
                </Typography>
              </FormControl>
              </div>
              <div>
              {fetchingFilter ? <LinearProgressBlockScreen />
              :
                <FormControl className={classes.formControlAutoCompleteDemonstrativo}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValueDemonstrativo}
                  suggestions={numerosDemostrativos}
                  maxSuggestions={3}
                  label={'*Número do demonstrativo recorrido'} />
              </FormControl>}
              <FormControl>                
                <TextField
                  label='*Nº do Protocolo de recebimento recorrido'
                  type='search'
                  className={classes.textFieldFilter}
                  value={numProtocoloSelected}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'numProtocoloSelected',
                  }}
                /> 
              </FormControl>             
              <FormControl className={classes.selectTipoGuia}>
                <InputLabel htmlFor='tipo-simple'>Tipo de Guias que serão inseridas no novo Lote</InputLabel>
                <Select
                  value={codTipoGuiaSelected}
                  onChange={this.handleChange}
                  inputProps={{
                  name: 'codTipoGuiaSelected',
                }}
                >
                <MenuItem value={1}>Guia de Consulta</MenuItem>
                <MenuItem value={2}>Guia de SP/SADT</MenuItem>
                <MenuItem value={3}>Guia de Resumo de Internação</MenuItem>
                <MenuItem value={4}>Guia de Honorário Individual</MenuItem>
                </Select>
              </FormControl>       
              </div>            
            </Paper>
            <Paper className={classes.body} elevation={1}>
              <div>
              <FormControl>
                <Typography className={classes.typographyTituloPaper}>
                Selecionar guias glosadas no demonstrativo/protocolo e que seráo inseridas no novo lote
                </Typography>
              </FormControl>
              </div>              
              <div className={classes.divAdicionarGuias}>
                <Button
                  disabled={(this.state.numDemonstrativoSelected === 0 && this.state.numProtocoloSelected === '') || this.state.codTipoGuiaSelected === 0}
                  color='primary'
                  variant='contained'
                  className={classes.buttonAdicionarGuias}
                  onClick={this.handleClickAdicionarGuias}
                  id={'adicionarGuias'}>
                  Adicionar Guias
                </Button>
              </div>
              {fetching ? <LinearProgressBlockScreen />
                : <Fade timeout={1000} in>
                  <Paper className={classes.body} elevation={1}>
                  {guias.length > 0 &&
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        data={guias}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>}
                  </Paper>
                </Fade>}              
            </Paper>
            <Paper className={classes.body} elevation={1}>
              <div>
              <FormControl>
                <Typography className={classes.typographyTituloPaper}>
                Informar dados do novo lote de recurso de glosa
                </Typography>
              </FormControl>
              </div>              
              <FormControl>                
                <TextField
                  label='*Nº do novo lote de recurso que será criado'
                  type='search'
                  className={classes.textFieldFilter}
                  value={numProtocoloNovoSelected}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'numProtocoloNovoSelected',
                  }}
                /> 
              </FormControl>             
              <FormControlLabel
              control={
                <Checkbox
                  checked={jaAuditadoPapel}
                  onChange={this.handleChangeJaAuditadoPapel}
                  name='jaAuditadoPapel'
                />
              }
              label='Lote de recurso já auditado em papel'
              className={classes.checkBox}
            />
            </Paper>
          </DialogContent>
          : <DialogContent>            
            <Paper className={classes.paperPrincipal} elevation={2}>
              <Typography className={classes.typographyLabelPaper}>
                  Número do Lote:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                    {this.state.lote.numLotePrestador}
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Número do Protocolo:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                    {this.state.lote.numProtocolo === null ? '-' : this.state.lote.numProtocolo}
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Prestador:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                    {this.state.lote.cpfCnpjPrestador} - {this.state.lote.nomPrestador}
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Lote Cancelado:
              </Typography>     
              {this.state.lote.indCancelado === 'S'
              ? <Typography className={classes.typographyDetalheCancelado}>
                  {this.state.lote.indCancelado === 'S' ? 'Sim' : 'Não'}
              </Typography>
              : <Typography className={classes.typographyDetalhe}>
              {this.state.lote.indCancelado === 'S' ? 'Sim' : 'Não'}
              </Typography>}
              <Typography className={classes.typographyLabelPaper}>
                  Tipo de Guia do Lote:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                    {this.state.lote.nomTipoGuia}
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Lote de Recurso de Glosa:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                  Sim
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Situação:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                {this.state.lote.situacao}
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Data de Recebimento:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                {this.state.lote.dtaRecebimentoProtocolo === null || this.state.lote.dtaRecebimentoProtocolo === '31/12/1969' ? '-' : this.state.lote.dtaRecebimentoProtocolo}
              </Typography>
              <Typography className={classes.typographyLabelPaper}>
                  Número da Fatura:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                {this.state.lote.txtNumeroFatura === null ? '-' : this.state.lote.txtNumeroFatura}
              </Typography>              
              <Typography className={classes.typographyLabelPaper}>
                  Número do Demonstrativo:
              </Typography>     
              <Typography className={classes.typographyDetalhe}>
                {this.state.lote.numDemonstrativoPag === null ? '-' : this.state.lote.numDemonstrativoPag}
              </Typography>              
            </Paper>

            <Paper className={classes.paperTotal} elevation={1}>
              <Typography className={classes.typographyTotalValor}>
                Total Geral Processado:
              </Typography>
              <Typography className={classes.typographyTotalValorDetalhe}>
                {nf.format(this.state.lote.valTotalProcessado)}
              </Typography>
              <Typography className={classes.typographyTotalValor} >
                Total Geral Glosado:
              </Typography>
              <Typography className={classes.typographyTotalValorDetalhe} color='secondary'>
                {nf.format(this.state.lote.valTotalGlosado)}
              </Typography>
              <Typography className={classes.typographyTotalValor}>
                Total Geral Liberado:
              </Typography>
              <Typography className={classes.typographyTotalValorDetalhe} color='primary'>
                {nf.format(this.state.lote.valTotalLiberado)}
              </Typography>
            </Paper>            

            <Paper className={classes.paperDetalhes} elevation={1}>
              <Typography className={classes.typographyLabelPaperRecurso}>
                  Número do DP Recorrido:
              </Typography>     
              <Typography className={classes.typographyDetalheRecurso}>
                    {this.state.lote.numDemonstrativoPagRecorrido}
              </Typography>
              <Typography className={classes.typographyLabelPaperRecurso}>
                  Nº Protocolo Recorrido:
              </Typography>     
              <Typography className={classes.typographyDetalheRecurso}>
                {this.state.lote.numProtocoloRecorrido}
              </Typography>
              <Typography className={classes.typographyLabelPaperRecurso}>
                  Data Limite para Envio Recurso:
              </Typography>     
              <Typography className={classes.typographyDetalheRecurso}>
                {this.state.lote.dtaFimRecGlosa === null ? '-' : (this.state.lote.dtaFimRecGlosa)}
              </Typography>
              <Typography className={classes.typographyLabelPaperRecurso}>
                  Lote Cadastrado pelo Assistente:
              </Typography>     
              <Typography className={classes.typographyDetalheRecurso}>
                {this.state.lote.indLoteRecursoAuditadoPapel === 'S' ? 'Sim' : 'Não'}
              </Typography>
            </Paper>            
            <Paper className={classes.paperHistorico} elevation={1}>
              {this.state.historicoLote.length > 0 &&
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={this.state.historicoLote}
                    columns={columnsHistorico}
                    options={optionsHistorico}
                  />
                </MuiThemeProvider>
              }
            </Paper>
            {fetching ? <LinearProgressBlockScreen />
            : <React.Fragment>
            {this.state.situacao === 'NÃO ENVIADO' &&
            <div className={classes.divAdicionarGuias}>
              <Button
                disabled={(this.state.numDemonstrativoSelected === 0 && this.state.numProtocoloSelected === '') || this.state.codTipoGuiaSelected === 0}
                color='primary'
                variant='contained'
                className={classes.buttonAdicionarGuias}
                onClick={this.handleClickAdicionarGuias}
                id={'adicionarGuias'}>
                Adicionar Guias
              </Button>
            </div>}        
            <Paper className={classes.body} elevation={1}>
              {guias.length > 0 &&
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={guias}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>}
            </Paper>
            </React.Fragment>}
          </DialogContent>}
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={
                (this.state.modoInclusao && this.state.guias.length === 0 && this.state.numProtocoloNovoSelected === '') ||
                (!this.state.modoInclusao && !this.state.adicionouGuias)
              }
              onClick={this.handleClickSave}
              color='primary'>
              Salvar
            </Button>
          </DialogActions>
        </Dialog>
        {openDialogGuias &&
        <FormDialogGuiasLoteRecurso
          open={openDialogGuias}
          handleClose={this.handleCloseAdicionarGuias}
          handleSave={this.handleSaveAdicionarGuias}
          titulo={'Adicionar Guias ao Lote de Recurso'}
          codTipoGuia={this.state.modoInclusao ? codTipoGuiaSelected : this.state.codTipoGuiaSelected} 
          numDemonstrativo={numDemonstrativoSelected}
          numProtocolo={numProtocoloSelected}
          guiasSelecionadas={guias}
          seqPrestador={this.state.seqPrestadorSelected}
          />}        
        <AlertDialogSlide
          open={this.state.openDialogEnvioFaturamento}
          handleClose={this.handleCloseDialogEnvioFaturamento}
          handleClick={this.handleDialogConfirmEnvioFaturamento}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage}
        />          
        {this.state.openDialogValidacao &&
          <DialogErrosDemonstrativos
            open={this.state.openDialogValidacao}
            handleClose={this.handleDialogValidacaoClose}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
            demonstrativosSemErros={this.state.demonstrativosSemErros}
            mensagemComplementar={'foi(ram) incluído(s) com sucesso.'} />
        }           
        {this.state.guiaOriginalOpen &&
        <DrawerGuiaRecurso
          loteSelecionado={this.state.lote}
          open={this.state.guiaOriginalOpen}
          guiaOriginal={this.state.guiaOriginal}
          handleClose={this.handleCloseGuiaOriginal}
          modoEdicaoGuia={this.state.modoEdicaoGuia}
        />}        
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
      </div>
    );
  }
}
export default withUsuario(withStyles(styles)(FormDialogLoteRecurso));
